import { Checkbox, type CheckboxProps } from '@mui/material';

/** Atlas-themed checkbox — relies on MuiCheckbox theme overrides (no custom icons). */
export function OnboardingCheckbox(props: CheckboxProps) {
  return <Checkbox {...props} sx={{ flexShrink: 0, ...props.sx }} />;
}
